import notify from '../../../core/components/notify/notify.component';
import i18n from '../../../i18n';

const showStatusCodeError = (statusCode: number): void => {
  switch (statusCode) {
    case 401:
      notify(i18n.t('unauthorized-error'), false);
      break;
    case 409:
      notify(i18n.t('duplicate-error'), false);
      break;
    case 204:
      notify(i18n.t('no-content-error'), false);
      break;
    case 428:
      notify(i18n.t('booking-acknowledgement-required-error'), false);
      break;
    case 452:
      notify(i18n.t('cant-remove-self-from-admin-error'), false);
      break;
    default:
      notify(i18n.t('edit-office-error-message'), false);
  }
};

export default showStatusCodeError;
